import { useEffect } from 'react'
import { useSpinDelay } from 'spin-delay'
import { useFactsSync } from '#app/utils/facts-sync-context'
import { useOptionalUser } from '#app/utils/user'
import { Icon } from './ui/icon'

export function FactsSyncIndicator() {
	const { isSyncing, startSync, endSync } = useFactsSync()
	const user = useOptionalUser()

	// Use spin delay to avoid showing the indicator for quick syncs
	const showSpinner = useSpinDelay(isSyncing, {
		delay: 400,
		minDuration: 300,
	})

	// Check for cookies that indicate FACTS sync is in progress
	useEffect(() => {
		// Check if the cookie exists that would indicate FACTS sync is in progress
		const isPostLogin = document.cookie.includes('facts-sync-success')

		if (isPostLogin && user) {
			// Start showing the sync indicator
			startSync()

			// Set a timeout to hide it after a reasonable time
			// This simulates the async operation completion
			const timer = setTimeout(() => {
				endSync()
				// Clear the cookie
				document.cookie = 'facts-sync-success=; Path=/; Max-Age=0;'
				// Reload the page to reflect the latest data
				window.location.reload()
			}, 3000)

			return () => clearTimeout(timer)
		}
	}, [user, startSync, endSync])

	if (!showSpinner) return null

	return (
		<div className="fixed right-4 top-4 z-50 flex items-center gap-2 rounded-md bg-muted px-3 py-2 shadow-md">
			<Icon
				name="update"
				className="animate-spin text-foreground"
				aria-hidden
			/>
			<span>Syncing with FACTS...</span>
		</div>
	)
}
